<template>
    <div style="width:100%;" :style="'height:' + height_image_paralax" id="paralax-image-learn">
        <v-container class="fill-height px-sm-10 px-md-15 container-main" style="align-content: center"
            :fluid="$vuetify.display.mdAndDown ? true : false">

            <v-row class="row-line mh-90" justify="center">
                <v-col cols="auto" align-self="end">
                    <v-expand-transition>
                        <h1 class="title-big" v-show="textAnim.showTextTitle">
                            <!-- {{ t("$vuetify.single_partner.about_title") }}  -->
                            {{ $vuetify.locale.current == 'ru' ?
                                Partner['name_ru'] : Partner['name_ro'] }}
                        </h1>
                    </v-expand-transition>
                </v-col>
            </v-row>

            <v-divider class="divider-partner my-4 my-sm-10 my-lg-13" color="info"></v-divider>

            <v-row style="width: 100%;" class="mx-0 mh-90">
                <v-expand-transition>
                    <v-btn variant="outlined" class="btn-allp rounded-pill px-12 mt-3" v-show="textAnim.showText"
                        :size="$vuetify.display.mdAndUp ? 'large' : 'default'" color="#F6F2E6"
                        @click="$router.push({ name: 'partners', params: { lang: $vuetify.locale.current } })">
                        {{ t("$vuetify.single_partner.all_partners_btn") }}
                    </v-btn>
                </v-expand-transition>
            </v-row>

            <breadcrumbs name="partners" :Partner="Partner" class="mt-15 " />
        </v-container>
    </div>
</template>

<script>
import { useLocale } from "vuetify";
import breadcrumbs from "../breadcrumbs.vue";

export default {
    name: "PartnerName",
    props: {
        Partner: Object,
    },
    components: {
        breadcrumbs
    },
    setup() {
        const { t } = useLocale();
        return {
            t,
        };
    },
    data: () => ({
        textAnim: {
            showTextTitle: false,
            showText: false,
        },
    }),
    mounted() {
        let vue = this;
        setTimeout(() => {
            vue.textAnim.showTextTitle = true;
        }, 800);
        setTimeout(() => {
            vue.textAnim.showText = true;
        }, 1300);

        /*  if (document.readyState == "complete") {
             setTimeout(() => {
                 vue.textAnim.showTextTitle = true;
             }, 800);
             setTimeout(() => {
                 vue.textAnim.showText = true;
             }, 1300);
         } else {
             document.addEventListener(
                 "PreloaderFinish",
                 () => {
                     setTimeout(() => {
                         vue.textAnim.showTextTitle = true;
                     }, 800);
                     setTimeout(() => {
                         vue.textAnim.showText = true;
                     }, 1300);
                 },
                 false
             );
         } */
    },
    computed: {
        height_image_paralax() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "auto";
                case "sm":
                    return "auto";
                case "md":
                    return "65vh";
                case "lg":
                    return "65vh";
                case "xl":
                    return "65vh";
                case "xxl":
                    return "50vh";
                default:
                    return "50vh";
            }
        },
    },
};
</script>

<style scoped>
.btn-allp {
    text-transform: inherit;
    letter-spacing: -0.02rem;
    font-weight: 400;
    font-size: 1.2rem;
}

.container-main {
    padding-top: 15vh;
}

.row-line {
    width: 100%;
}

.title-small2 {
    color: #c4c4c4;
    font-weight: 400;
    letter-spacing: -0.035rem !important;
}

.title-small {
    color: #c4c4c4;
    font-weight: 400;
    letter-spacing: -0.04rem !important;
    text-shadow: 8px 13px 35px rgba(0, 0, 0, 0.5);
}

.mh-90 {
    min-height: 69px;
}

.title-big {
    letter-spacing: -0.02rem !important;
    color: #f6f2e6;
    text-shadow: rgba(0, 0, 0, 0.87) 0px 4px 30px;
    font-size: 3rem;
    font-weight: 400;
    line-height: 3rem;
}

.divider-partner {
    border-width: 1px;
    opacity: 1;
    border-image-slice: 1;
    border-image-source: linear-gradient(to right, rgba(246, 242, 230, 0.36), rgba(255, 255, 255, 0));
}

@media screen and (max-width: 600px) {
    .title-big {
        font-size: 1.9rem;
        line-height: 1.9rem;
    }

    .title-small,
    .title-small2 {
        font-size: 0.85rem !important;
        line-height: 1.1rem !important;
    }

    .row-line {
        height: unset !important;
    }

    .btn-allp {
        font-size: 1rem;
    }

    .mh-90 {
        min-height: 55px;
    }

}

@media screen and (min-width: 600px) and (max-width: 960px) {
    .title-big {
        zoom: 0.8;
    }

    .title-small,
    .title-small2 {
        zoom: 0.8;
    }
}
</style>